export const AS = {
    translations: {
        notifications: 'জাননীসমূহ',
        markAllAsRead: 'সকলো পঢ়া হিচাপে চিহ্নিত কৰক',
        poweredBy: 'দ্বাৰা সমৰ্থিত',
        settings: 'ছেটিংছ',
        noNewNotification: 'ইয়াত এতিয়াও নতুন একো দেখা নাই',
    },
    lang: 'as',
};
//# sourceMappingURL=as.js.map